import styled from 'styled-components';
import { ellipsisText, FlexBetween } from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';

const iconSize = '18px';
const searchBarSize = '54px';

export const SearchBar = styled(FlexBetween)`
  position: relative;
  border-radius: 14px;
  padding: 0 10px;
  height: ${searchBarSize};
  cursor: pointer;
  flex: 1;
  min-width: 0;
  background-color: ${({ theme }) => theme.colors.background.primary};

  &::-webkit-scrollbar {
    display: none;
  }

  input[type='text'] {
    border-style: none;
    width: 100%;
    color: ${({ theme }) => theme.colors.text.secondary};
    padding: ${iconSize} 0;
    background: transparent;
    ${ellipsisText}

    &:focus {
      outline: none;
    }
  }
`;

export const SearchBarText = styled(FlexBetween)`
  width: 100%;
  height: 100%;
`;

export const SearchBarLocations = styled.div`
  ${ellipsisText};
  color: ${({ theme }) => theme.colors.text.primary};
  width: 100%;
  max-width: 100%;
`;

export const SearchBarCity = styled(Typography)`
  color: ${({ theme }) => theme.colors.systemColors.blue};
  padding: 18px 0;
  padding-left: 10px;
  cursor: pointer;
  white-space: nowrap;
`;

export const SearchBarPlaceholder = styled.div`
  font-size: 15px;
  color: ${({ theme }) => theme.colors.text.primary};
  ${ellipsisText};

  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.colors.systemColors.blue};
    }
  }
`;
